import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store.js";
import { derived } from "svelte/store";
import { getUsersAndGroupsData } from "./apiCalls.js";

// TODO - move functionality of users_and_groups API call to a SwApiStore
const [usersAndGroups] = await getUsersAndGroupsData();

export const { users } = usersAndGroups;
export const { groups } = usersAndGroups; // NOTE: sorting occurs on BE
export const { teamId } = usersAndGroups;
export const { viewerId } = usersAndGroups; // important to handle userIds of the type <userId>^<teamId>

export const showCampaignTypes = usersAndGroups.teamKind === "agency";
export const defaultSelectedUser = usersAndGroups.users.find(
  (user) => user.isCurrentUser,
);

/* -------------------------- */
/* DASHBOARD VIEW PERMISSIONS */
/* -------------------------- */

export const isDashboardAdmin = derived(
  userStore,
  ($userStore) =>
    $userStore.isOnAnotherTeam ||
    ["superUser", "viewer"].includes($userStore.kind),
);

export const userIsOnOtherTeam = derived(
  userStore,
  ($userStore) => $userStore.isOnAnotherTeam,
);

/* ------- */
/* DIALLER */
/* ------- */

export const teamHasDialler = usersAndGroups.hasDialler; // NOTE this signifies whether the team have dialler enabled
